import * as React from "react"
import * as ReactDOM from "react-dom/client"

import { I18nProvider } from "@/lib/i18n/client"
import { AppProviders } from "@/components/app-providers"
import { SiteHeader } from "@/components/layout/site-header"
import { SiteFooter } from "@/components/layout/site-footer"
import { MobileBottomCta } from "@/components/layout/mobile-bottom-cta"
import { HeroSection } from "@/components/sections/hero-section"
import { CoreStatsSection } from "@/components/sections/core-stats-section"
import { PurchaseFlowSection } from "@/components/sections/purchase-flow-section"
import { Trc20Section } from "@/components/sections/trc20-section"
import { SecuritySection } from "@/components/sections/security-section"
import { OrdersTickerSection } from "@/components/sections/orders-ticker-section"
import { TestimonialsSection } from "@/components/sections/testimonials-section"
import { FaqSection } from "@/components/sections/faq-section"

import "@/styles/globals.css"

function App() {
  return (
    <I18nProvider>
      <AppProviders>
        <SiteHeader />
        <main className="pb-24 md:pb-0">
          <HeroSection />
          <CoreStatsSection />
          <PurchaseFlowSection />
          <Trc20Section />
          <SecuritySection />
          <OrdersTickerSection />
          <TestimonialsSection />
          <FaqSection />
        </main>
        <SiteFooter />
        <MobileBottomCta />
      </AppProviders>
    </I18nProvider>
  )
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
